import EditOnboardingFormPage from "../pages/EditOnboardingFormPage";
// Feature code groups for Navbar rendering
export const FEATURE_GROUPS = {
  seller_university: ["ssu_basic", "ssu_downloadables", "ssu_mentorship"],
  certification_suite: ["3sc_score", "3sc_certification", "3sc_seo_landing"],
  // Add other feature groups as needed
};

export const FEATURE_PAGE_MAP = {
  SSU_BASIC: {
    route: "/seller-university",
    label: "Seller University",
    component: "SellerUniversity",
    group: "seller_university",
    comingSoon: true,
  },
  SSU_DOWNLOADABLES: {
    route: "/seller-university",
    label: "Seller University",
    component: "SellerUniversity",
    group: "seller_university",
    comingSoon: true,
  },
  SSU_MENTORSHIP: {
    route: "/seller-university",
    label: "Seller University",
    component: "SellerUniversity",
    group: "seller_university",
    comingSoon: true,
  },
  SUSPIRE_CIRCLE: {
    route: "/suspire-circle",
    label: "Suspire Circle",
    component: "InternalMessagesPage",
  },
  PRODUCT_LISTING: {
    route: "/brand-product-content",
    label: "Product Listing",
    component: "BrandProductContentPage",
    comingSoon: true,
  },
  COMMUNITY_FORUM: {
    route: "/forum",
    label: "Community Forum",
    component: "CommunityForum",
    comingSoon: true,
  },
  BRAND_DASHBOARD: {
    route: "/brand-dashboard",
    label: "Brand Dashboard",
    component: "BrandDashboard",
    comingSoon: true,
  },
  "3SC_SCORE": {
    route: "/certification",
    label: "3SC Score Tracking",
    component: "CertificationDashboard",
    group: "certification_suite",
    comingSoon: true,
  },
  "3SC_CERTIFICATION": {
    route: "/sustainability",
    label: "3SC Certification Suite",
    component: "3SClandingPage",
    group: "certification_suite",
    comingSoon: false,
  },
  "3SC_SEO_LANDING": {
    route: "/certification",
    label: "3SC SEO Landing Page",
    component: "CertificationDashboard",
    group: "certification_suite",
    comingSoon: true,
  },
  SUSPIRE_SUPPORT_NETWORK: {
    route: "/suspire-support-network",
    label: "Suspire Support Network",
    component: "SSN",
    comingSoon: false,
  },
  //   SSN: {
  //   route: '/suspire-support-network',
  //   label: 'Suspire Support Network',
  //   component: 'SuspireSupportNetwork',
  //   comingSoon: false,
  // },
  INSPIRE_AI_LANDING: {
    route: "/inspire-ai",
    label: "Inspire AI Landing Page",
    component: "BrandInspirePage",
    comingSoon: true,
  },
  GROWTH_SUITE: {
    route: "/growth-suite",
    label: "Growth Suite",
    component: "ActivityDashboard",
  },
  AI_BANNER_GENERATION: {
    route: "/ai-banner-suggestions",
    label: "AI Banner Generation",
    component: "AIBannerSuggestionsPage",
    comingSoon: true,
  },
  PERFORMANCE_EMAIL_CALENDAR: {
    route: "/brand-email-calendar",
    label: "Performance Email Calendar",
    component: "BrandEmailCalendarPage",
    comingSoon: true,
  },
  BRAND_MANAGEMENT: {
    route: "/brands",
    label: "Brand Management",
    component: "BrandsPage",
  },
  CUSTOMER_CRM: {
    route: "/customer-crm",
    label: "Customer CRM",
    component: "CustomerCRM",
    comingSoon: true,
  },
  SUSPIRE_VISIBILITY_CALENDAR: {
    route: "/suspire-visibility",
    label: "Suspire Visibility Calendar",
    component: "SuspireVisibilityCalendar",
    comingSoon: true,
  },
  MARKETING_AUTOMATION: {
    route: "/brand-genai-marketing",
    label: "Marketing Automation",
    component: "BrandGenAIMarketingDemo",
    comingSoon: true,
  },
  SUSPIRE_TERMINAL: {
    route: "/suspire-terminal",
    label: "Suspire Terminal",
    component: "Shipturtle",
    comingSoon: false,
  },
  EDIT_ONBOARDING_FORM: {
    route: "/edit-onboarding-form",
    label: "Edit Onboarding Form",
    component: "EditOnboardingFormPage",
    comingSoon: false,
  },
  SUPPORT_TICKETS: {
    route: "/suspire-helpdesk",
    label: "Suspire Helpdesk",
    component: "InternalMessagesPage",
    comingSoon: false,
  },
};
